import { z } from "zod";

export const DocumentationPageApprovalState = z.enum(["ReadyForReview", "ChangesRequested", "Approved"]);
export type DocumentationPageApprovalState = z.infer<typeof DocumentationPageApprovalState>;
